<script setup>

import { KNOLIA } from "@/knolia";
import { ref, onUpdated, onMounted } from "vue";
import { Gems } from "../gems";
import ActivitiesJobRow from "../components/ActivitiesJobRow.vue";
import DropZone from "../components/DropZone.vue";
import { useDragAndDrop } from "../store/modules/drag-and-drop";
import { MESSAGES } from "../messages";

const jobs = ref([])
const activities = ref([])
const jobActivities = ref([])

const currentJob = ref({name: null, id: null})
const showAllTasks = ref(false)
const showAllJobTasks = ref(false)
const dragAndDrop = useDragAndDrop()
const dropZone = ref(null)
const isLowerThanMobile = ref(KNOLIA.updateIsLowerThanMobile())
const isMobile = ref(KNOLIA.updateIsMobile())


async function getjobActivities(job_name, job_id) {
    currentJob.value.name = job_name
    currentJob.value.id = job_id

    const response = await KNOLIA.CallBackEnd('post', 'get-activities-list', { params: { job_id } })
    if(jobActivities.value.length > 0)
        response.data.forEach(elem => {
            const ind = jobActivities.value.findIndex(job_elem => job_elem.id == elem.id)
            Object.assign(elem, {showChildren: jobActivities.value[ind]?.showChildren})
        })

    jobActivities.value = response.data
    SetActivitiesAccess()
}



function RemoveTask(index) {
    jobActivities.value.splice(index, 1)
    SetActivitiesAccess()
}

function SetActivitiesAccess() {
    activities.value.forEach(activity => {
        if(showAllTasks.value)
            activity.showChildren = true

        activity.unavailable = false
        jobActivities.value.forEach(jobActivity => {
            if(activity.id == jobActivity.id)
            activity.unavailable = true
        })
    })
}

function ShowAllChildren(jobTasks) {
    if(jobTasks) {
        showAllJobTasks.value = !showAllJobTasks.value
        jobActivities.value.forEach(activity => activity.showChildren = showAllJobTasks.value)
    } else {
        showAllTasks.value = !showAllTasks.value
        activities.value.forEach(activity => activity.showChildren = showAllTasks.value) 
    }
}

async function ApplyToUsers() {
    const response = await KNOLIA.CallBackEnd('post', 'set-operations&get=apply-job-definitions-to-user', { params: { job_id: currentJob.value.id } })
    if(response.error)
        Gems.Telegram(MESSAGES.ERROR.DEFAULT, 'tele-not-allowed')
    else
        Gems.Telegram(MESSAGES.SUCCESS.APPLIED, 'tele-success')
}

onMounted(async () => {
    const responseActivities = await KNOLIA.CallBackEnd('post', 'get-activities-list')
    activities.value = responseActivities.data.filter(activity => activity.included)

    const responseFunctions = await KNOLIA.CallBackEnd('get', 'get-operations', {
        params: {
            get: 'functions'
        }
    })
    jobs.value = responseFunctions.data

    dragAndDrop.setDropFunction(async function () {

        if(currentJob.value.id == null)
            return 

        await KNOLIA.CallBackEnd('post', `set-operations&get=task-to-job&job_id=${currentJob.value.id}`, {
            tasks: dragAndDrop.DraggedData.tasks, activity: dragAndDrop.DraggedData.activity
        })
        
        getjobActivities(currentJob.value.name, currentJob.value.id)
    }, dropZone.value)
})

onUpdated(() => {
    jobActivities.value.forEach((elem, i) => {
        const removeIcon = document.getElementById(`remove-task-${i}`)

        if(removeIcon)
            Gems.Tooltip(removeIcon, 'Remover atividade da função', 'tooltip')
    })
})

window.addEventListener('resize', () => {
  isMobile.value = KNOLIA.updateIsMobile()
  isLowerThanMobile.value = KNOLIA.updateIsLowerThanMobile()
})

</script>

<template>
    <div class="splitter page-container">
        <div id="div-activities-container">
            <div class="div-default-title pb-1" v-if="isMobile || isLowerThanMobile">
                <span>Funções</span>
            </div>

            <div class="div-default-title div-title-container pb-1" v-else>
                <span>Atividades</span>
                <div class="cursor-pointer div-show-all" @click="ShowAllChildren(false)">
                    Expandir/Fechar todos
                </div>
            </div>

            <div id="div-activities" class="group-frame scrollbar">
                <ActivitiesJobRow :activities="activities" :current-job="currentJob" :draggable="true" @remove-task="RemoveTask($event)" v-if="!isMobile && !isLowerThanMobile"/>
                
                <div v-else class="div-job div-row" :class="{'bg-alt-line': currentJob.id == job.func_id}" v-for="job in jobs" :key="job.func_id" @click="getjobActivities(job.func_desc, job.func_id)">
                    <span class="line-clamp line-clamp-1" @mouseover="Gems.TooltipIfNeeded($event.target)">{{ job.func_desc }}</span>
                    <i class="fas" :class="{'fa-chevron-right': currentJob.id == job.func_id}"></i>
                </div>
            </div>
        </div>

        <div class="row p-0 m-0">
            <div class="col-12 col-sm-6 col-md-5 p-0 m-0 pe-1 pt-3">
                <div class="div-default-title pb-1" v-if="!isMobile && !isLowerThanMobile">
                    <span>Funções</span>
                </div>

                <div class="div-default-title div-title-container pb-1" v-else>
                    <span>Atividades</span>
                    <div class="cursor-pointer div-show-all" @click="ShowAllChildren(false)">
                        Expandir/Fechar todos
                    </div>
                </div>
                
                <div class="group-frame scrollbar">
                    <div v-if="!isMobile && !isLowerThanMobile">
                        <div class="div-job div-row" :class="{'bg-alt-line': currentJob.id == job.func_id}"
                            v-for="job in jobs" :key="job.func_id" @click="getjobActivities(job.func_desc, job.func_id)">
                            <span class="line-clamp line-clamp-1" @mouseover="Gems.TooltipIfNeeded($event.target)">{{ job.func_desc }}</span>
                            <i class="fas" :class="{'fa-chevron-right': currentJob.id == job.func_id}"></i>
                        </div>
                    </div>

                    <ActivitiesJobRow :activities="activities" :current-job="currentJob" :draggable="true" @remove-task="RemoveTask($event)" v-else/>
                </div>
            </div>

            <div class="col-12 col-sm-6 col-md-7 p-0 m-0 ps-1 pt-3">
                <div class="div-default-title div-title-container pb-1">
                    <span class="line-clamp line-clamp-1">Atividades [{{ currentJob.name ?? 'Escolha uma função' }}]</span>
                    <div class="cursor-pointer div-show-all line-clamp line-clamp-1" @click="ShowAllChildren(true)">
                        Expandir/Fechar todos
                    </div>
                </div>

                <div class="group-frame scrollbar">
                    <button class="ddl-alt-padding d-flex justify-self-end mb-1" @click="ApplyToUsers()" v-if="jobActivities.length > 0"> Aplicar a todos da função </button>
                    <div ref="dropZone">
                        <DropZone id="drop-zone"/>                    
                    </div>
                    <ActivitiesJobRow :activities="jobActivities" :current-job="currentJob" :draggable="false" @remove-task="RemoveTask($event)" @get-job-activities="getjobActivities(currentJob.name, currentJob.id)"/>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

.group-frame {
    height: 380px;
    text-align: left;
    padding: 6px;
}

.div-row {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    padding: 9px 15px;
    cursor: pointer;
    align-items: center;
    border-radius: 25px;
}

.div-row:hover {
    background-color: var(--default-app-alt-line-color);
}

.div-title-container {
    display: flex;
    justify-content: space-between;
}

.div-show-all {
    font-size: 1rem;
    font-weight: normal !important;
    align-content: end;
}

.justify-self-end {
    justify-self: flex-end;
}

@media screen and (max-width: 700px) {
    .div-default-title,
    .div-job {
        font-size: .9em;
    }

    .div-show-all {
        font-size: .7rem;
    }
}

</style>